import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { FilterFilled } from "@ant-design/icons";
import { Dropdown, Menu, Checkbox } from "antd";
import { isEmpty } from "lodash";
const RegularFilter = ({ value, onChange, options }) => {
    const [selectedOptions, setSelectedOptions] = useState(value || []);
    const [open, setOpen] = useState(false);
    const onSelect = (optionValue) => {
        const checked = !selectedOptions.includes(optionValue);
        const updatedSelectedOptions = checked
            ? [...selectedOptions, optionValue]
            : selectedOptions.filter((val) => val !== optionValue);
        setSelectedOptions(updatedSelectedOptions);
        onChange(updatedSelectedOptions);
    };
    const isActive = useMemo(() => {
        return !isEmpty(value);
    }, [value]);
    const filterOptions = useMemo(() => (_jsx(Menu, { onClick: ({ domEvent }) => {
            domEvent.preventDefault();
            domEvent.stopPropagation();
        }, multiple: true, selectable: true, children: options === null || options === void 0 ? void 0 : options.map(({ label, value }) => (_jsx("div", { className: "prefs-flex prefs-items-center prefs-gap-x-2 ant-dropdown-menu-item", onClick: (e) => {
                e.preventDefault();
                onSelect(value);
            }, children: _jsxs(Checkbox, { checked: selectedOptions.includes(value), children: ["\u00A0", label] }) }, value))) })), [value, options, selectedOptions]);
    const dropdownContent = useMemo(() => {
        return _jsx("div", { style: { minWidth: 120 }, children: filterOptions });
    }, [value, options, selectedOptions]);
    if (isEmpty(options))
        return null;
    return (_jsx("div", { onClick: (e) => e.stopPropagation(), children: _jsx(Dropdown, { visible: open, onVisibleChange: setOpen, overlay: dropdownContent, trigger: ["click"], overlayClassName: "ant-table-filter-dropdown", children: _jsx(FilterFilled, { className: `ant-table-filter-trigger ${isActive ? "active" : ""}` }) }) }));
};
export default RegularFilter;
